import api from "!../../../packages/thebe/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../packages/thebe/node_modules/css-loader/dist/cjs.js!./abcdef.css";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};